import store from './store';
import CONST from '../src/utils/const';

let currentServerHost = location.hostname;
let currentHost = location.host;
if (process.env.NODE_ENV === 'development') {
  currentServerHost = process.env.VUE_APP_DEV_SERVER
}

if (location.host === CONST.ACTIVITY_CLOUD_DOMAIN) {
  currentHost = CONST.EXTRA_DOMAIN_NAME;
}
console.log('location.host', currentHost);
export const GOOGLE_MAP_KEY = process.env.VUE_APP_GOOGLE_MAP

export default {
  currentServerHost,
  iSurveillanceUrl: () => {
    return `https://${currentHost}/playback/eastcoast/` //nginx
    // return 'https://10.179.2.35/eastcoast'
    // return 'http://192.168.8.71:8080/eastcoast/'
    // return 'http://localhost:8080/eastcoast/'
    // return 'http://192.168.50.85:8080/eastcoast/'
  },
  dynamicElaticSearchApi: () => {
    if (store.state.config) {
      const publicHostSetting = store.state.config.publicHostSetting
      const {
        protocol,
        hostname,
        port,
        elaticSearchPath
      } = publicHostSetting
      if (currentServerHost === hostname) {
        return `${protocol ? (protocol + ':') : location.protocol}//${hostname}:${port}${elaticSearchPath}`
      }
    }

    // return `https://${currentHost}/es/` //nginx
    // return `http://${currentServerHost}:9200/`
    // return 'http://192.168.50.85:9200/'
    // return `https://10.179.20.35/es/` //nginx

    return `https://imts.eastcoast-nsa.gov.tw/es/` //nginx
  },
  eastCoastDataApi: () => {
    // return `https://${currentHost}/EastCoast.DataApi/api/` //nginx
    // return 'http://192.168.50.85/EastCoast.DataApi/api/'
    // return 'https://10.179.2.35/EastCoast.DataApi/api/'                       
    // return 'http://10.179.20.35/EastCoast.DataApi/api/'
    //return 'https://localhost:44394/api/'
    return 'https://imts.eastcoast-nsa.gov.tw/EastCoast.DataApi/api/'

  },
  eastCoastMonitorApi: () => {
    // return `https://${currentHost}/apiservice/api/EastCoastApiService/`  //nginx
    // return 'https://10.179.2.35:5000/api/EastCoastApiService/'
    // return 'http://10.179.20.35:5000/api/EastCoastApiService/'
    // return 'http://192.168.50.85:5000/api/EastCoastApiService/'
    return 'https://imts.eastcoast-nsa.gov.tw/apiservice/api/EastCoastApiService/'

  }
}